<!-- 成为开发者 -->
<style scoped>
.becomeDeveloper {
    width: 100%;
}
.introduceA {
    width: 100%;
    padding: 20px 0 30px;
    background-color: #ffffff;
}
.introduceA .introduceAContent {
    width: 1200px;
    margin: 0 auto;
}
.introduceA .introduceAContent h2 {
    text-align: center;
    color: #000000;
    font-size: 36px;
    font-weight: bold;
}
.introduceA .introduceAContent .introduceAImg {
    width: 100%;
    height: 228px;
    margin-top: 25px;
}
.introduceA .introduceAContent .introduceAImg ul {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
}
.introduceA .introduceAContent .introduceAImg ul li {
    display: inline-block;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceA .introduceAContent .introduceAImg ul li a {
    display: inline-block;
}
.introduceA .introduceAContent .introduceAImg ul li.step {
    width: 262px;
    height: 229px;
    padding: 85px 35px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.introduceA .introduceAContent .introduceAImg ul li.step.step1 {
    background-image: url(../../assets/images/becomeDeveloperA1.png);
}
.introduceA .introduceAContent .introduceAImg ul li.step.step2 {
    background-image: url(../../assets/images/becomeDeveloperA2.png);
}
.introduceA .introduceAContent .introduceAImg ul li.step.step3 {
    background-image: url(../../assets/images/becomeDeveloperA3.png);
}
.introduceA .introduceAContent .introduceAImg ul li.step.step4 {
    position: relative;
    padding: 0;
    text-align: center;
    line-height: 209px;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background-image: url(../../assets/images/becomeDeveloperA4.png);
}
.introduceA .introduceAContent .introduceAImg ul li.step.step4 a {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
}
.introduceA .introduceAContent .introduceAImg ul li.step .tit {
    color: #000000;
    font-size: 22px;
    font-weight: bold;
}
.introduceA .introduceAContent .introduceAImg ul li.step .txt {
    margin-top: 10px;
    color: #666666;
    font-size: 14px;
    line-height: 24px;
}
.introduceA .introduceAContent .introduceAImg ul li.step:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.bg {
    position: relative;
    width: 100%;
    height: 1020px;
}
.bg .bgA {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 474px;
    background-color: #f0f0f0;
}
.bg .bgB {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 546px;
    background: url(../../assets/images/becomeDeveloperBg.png)no-repeat center center;
}
.BCcontent {
    position: relative;
    width: 1200px;
    padding-top: 50px;
    margin: 0 auto;
}
.introduceB {
    width: 100%;
}
.introduceB ul,
.introduceC ul {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    width: 100%;
    margin-top: 40px;
}
.introduceB ul li {
    display: inline-block;
    width: 590px;
    height: 420px;
    background-color: #ffffff;
    border: 1px solid #e5e8ed;
    border-radius: 5px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceB ul li .tit {
    padding: 20px 0 15px;
    font-size: 22px;
    color: #000000;
    text-align: center;
}
.introduceB ul li .txt {
    position: relative;
    padding: 0 30px 0 40px;
    line-height: 24px;
    font-size: 14px;
    color: #666666;
}
.introduceB ul li .txt span {
    position: absolute;
    top: 0;
    left: 22px;
}
.introduceB ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.introduceB ul li img,
.introduceC ul li img {
    width: 100%;
}
.introduceC {
    width: 100%;
    margin-top: 40px;
}
.introduceC ul li {
    display: inline-block;
    height: 260px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceC ul li:first-child {
    width: 650px;
}
.introduceC ul li:last-child {
    width: 549px;
}
.introduceC ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.introduceC .contactBox {
    width: 550px;
    height: 260px;
    padding: 40px 0 0 50px;
    background-color: #ffffff;
    border: 1px solid #e5e8ed;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.introduceC .contactBox p {
    color: #666666;
    font-size: 14px;
    line-height: 24px;
    margin-top: 20px;
}
.introduceC .contactBox p:first-child {
    margin-top: 0;
}
.introduceC .contactBox p i {
    display: inline-block;
    margin-right: 20px;
    vertical-align: middle;
}
.introduceC .contactBox p i.contactIcon1 {
    width: 23px;
    height: 24px;
    background-image: url(../../assets/images/contactIcon1.png);
}
.introduceC .contactBox p i.contactIcon2 {
    width: 24px;
    height: 25px;
    background-image: url(../../assets/images/contactIcon2.png);
}
.introduceC .contactBox p i.contactIcon3 {
    width: 24px;
    height: 17px;
    background-image: url(../../assets/images/contactIcon3.png);
}
.introduceC .contactBox p i.contactIcon4 {
    width: 21px;
    height: 27px;
    margin-left: 2px;
    background-image: url(../../assets/images/contactIcon4.png);
}
</style>
<template>
    <div class="becomeDeveloper">
        <banner></banner>
        <div class="introduceA">
            <div class="introduceAContent">
                <h2>即刻成为开发者，赋能企业服务客户能力，开启5G消息应用新时代。</h2>
                <div class="introduceAImg">
                    <ul>
                        <li class="step step1">
                            <p class="tit">免费注册</p>
                            <p class="txt">在彩讯CSP注册页进行免费注册，提交申请成为CSP的开发者。</p>
                            <!-- <img src="@/assets/images/becomeDeveloperA1.png" /> -->
                        </li>
                        <li>
                            <img src="@/assets/images/becomeDeveloperAIcon.png" />
                        </li>
                        <li class="step step2">
                            <p class="tit">信息完善</p>
                            <p class="txt">在线提交营业执照、身份证等企业相关信息，并按指引完成验证审核。</p>
                            <!-- <img src="@/assets/images/becomeDeveloperA2.png" /> -->
                        </li>
                        <li>
                            <img src="@/assets/images/becomeDeveloperAIcon.png" />
                        </li>
                        <li class="step step3">
                            <p class="tit">开通使用</p>
                            <p class="txt">审核通过后，即可使用CSP平台的所有功能，进行5G消息应用号的开发。</p>
                            <!-- <img src="@/assets/images/becomeDeveloperA3.png" /> -->
                        </li>
                        <li>
                            <img src="@/assets/images/becomeDeveloperAIcon.png" />
                        </li>
                        <li class="step step4">
                            成为开发者
                            <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bg">
            <div class="bgA"></div>
            <div class="bgB"></div>
            <div class="BCcontent">
                <div class="introduceB">
                    <modularTit :titleName="'合作模式'"></modularTit>
                    <ul>
                        <li>
                            <img src="@/assets/images/introduceB1.png" />
                            <p class="tit">SaaS化服务</p>
                            <p class="txt"><span>1、</span>通过平台注册，提供企业资质材料，审核通过即可开户完成。开户完成后可直接使用平台和能力。</p>
                            <p class="txt"><span>2、</span>提供平台可视化配置、消息API、业务接口配置工具等多种业务对接方式，企业可直接配置使用，或通过API集成完成消息应用的快速落地；</p>
                            <p class="txt"><span>3、</span>提供增值服务的自助式订购管理，支持企业通过消息和场景模板、能力开放API等方式与消息场景集成。</p>
                        </li>
                        <li>
                            <img src="@/assets/images/introduceB2.png" />
                            <p class="tit">私有化部署</p>
                            <p class="txt"><span>1、</span>将相关服务部署在客户私有化服务器，适用于分省移动、CSP代理及数据敏感类行业客户。</p>
                            <p class="txt"><span>2、</span>消息内容、任务、用户管理及MAAP层对接，基础消息服务全流程数据不外泄，保障高度数据私密；</p>
                            <p class="txt"><span>3、</span>基于客户需求，定制化业务系统对接模块，支持客户选配增值应用，进行模块化部署和权限开通。</p>
                        </li>
                    </ul>
                </div>
                <div class="introduceC">
                    <modularTit :titleName="'联系我们'"></modularTit>
                    <ul>
                        <li>
                            <img src="@/assets/images/introduceC1.png" />
                        </li>
                        <li class="contactBox">
                            <p><i class="contactIcon1"></i>商务合作：陈经理</p>
                            <p><i class="contactIcon2"></i>联系电话：4008-303-123</p>
                            <p><i class="contactIcon3"></i>工作邮箱：csp@richinfo.cn</p>
                            <p><i class="contactIcon4"></i>办公地址：深圳市南山区科苑南路3176号彩讯科创中心</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <introduce></introduce>
    </div>
</template>
<script>
import banner from '@/components/banner'
import modularTit from '@/components/modularTit'
import introduce from "@/components/introduce.vue"

export default {
    name: 'becomeDeveloper',
    components: {
        banner,
        modularTit,
        introduce
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/becomeDeveloper/index.vue